import { useTranslation } from '@/clientWeb/i18n/LanguageContext'

interface GettingReadyPanelProps {
  showReadyToJoin: boolean
}

export function GettingReadyPanel({ showReadyToJoin }: GettingReadyPanelProps) {
  const t = useTranslation()
  return (
    <div
      className={[
        'transition-opacity duration-700 ease-in-out',
        showReadyToJoin ? 'opacity-0 pointer-events-none absolute inset-0' : 'opacity-100',
      ].join(' ')}
    >
      <div className="flex flex-col items-center justify-center py-12">
        <div className="mb-6 flex items-center gap-2">
          <span className="h-4 w-4 rounded-full bg-[#0C5A96]/70 dark:bg-secondary animate-[dotPulse_0.9s_ease-in-out_infinite]" />
          <span className="h-4 w-4 rounded-full bg-[#0C5A96]/70 dark:bg-secondary animate-[dotPulse_0.9s_ease-in-out_infinite_0.15s]" />
          <span className="h-4 w-4 rounded-full bg-[#0C5A96]/70 dark:bg-secondary animate-[dotPulse_0.9s_ease-in-out_infinite_0.3s]" />
          <span className="h-4 w-4 rounded-full bg-[#0C5A96]/70 dark:bg-secondary animate-[dotPulse_0.9s_ease-in-out_infinite_0.3s]" />
        </div>
        <div className="text-lg font-semibold text-slate-900 dark:text-foreground">
          {t('dashboard.gettingReady')}
        </div>
        <div className="mt-1 text-sm text-slate-500 dark:text-muted-foreground">
          {t('dashboard.setupAudioVideo')}
        </div>
      </div>
    </div>
  )
}
